export default __webpack_public_path__ + "static/media/dashmania_demo_image.bd8a8d82.png";